import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ensureTransaction } from '../../util/data';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/UI.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';
import { fetchNumberOfPendingServiceFees, fetchNumberOfCartPreorders } from '../../ducks/user.duck';
import {
  cancelServiceFee,
  loadData,
  setInitialValues,
  cancelServiceFeeClear
} from './ServiceFeePage.slice';
import {
  Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ServiceFeePanel,
} from '../../components';
import { TopbarContainer } from '../../containers';

import css from './ServiceFeePage.css';

const PROVIDER = 'provider';
const CUSTOMER = 'user';

export const ServiceFeePageComponent = props => {
  const {
    fetchServiceFeeInProgress,
    fetchServiceFeeError,
    transactionRef,
    cancelInProgress,
    currentUser,
    scrollingDisabled,
    transaction,
    history,
    intl,
    params,
    onCancel,
    callSetInitialValues,
    onInitializeCardPaymentData,
    transactionRole,
    pageName,
    transactionSuccessComponent,
    cancelServiceFeeError,
    cancelServiceFeeSuccess,
    onCancelServiceFeeClear
  } = props;
  const currentTransaction = ensureTransaction(transaction);
  const dispatch = useDispatch();

  useEffect(() => {
    if (pageName === "ServiceFeeDetailsSuccessPage") {
      dispatch(fetchNumberOfPendingServiceFees());
      dispatch(fetchNumberOfCartPreorders())
    }
  }, []);

  // Redirect users with someone else's direct link to their own inbox/sales or inbox/orders page.
  const isDataAvailable =
    currentUser &&
    currentTransaction.id &&
    currentTransaction.id.uuid === params.id &&
    currentTransaction.attributes.lineItems &&
    currentTransaction.user &&
    currentTransaction.provider &&
    !fetchServiceFeeError;

  const loadingOrFailedFetching = fetchServiceFeeError ? (
    <p className={css.error}>
      <FormattedMessage id="ServiceFeePage.fetchFailed" />
    </p>
  ) : (
    <p className={css.loading}>
      <FormattedMessage id="ServiceFeePage.loadingData" />
    </p>
  );

  const panel = isDataAvailable ? (
    <ServiceFeePanel
      className={classNames(css.tabContent, css.tabContentVisible)}
      currentUser={currentUser}
      transaction={currentTransaction}
      transactionRole={transactionRole}
      onCancel={onCancel}
      cancelInProgress={cancelInProgress}
      history={history}
      pageName={pageName}
      callSetInitialValues={callSetInitialValues}
      onInitializeCardPaymentData={onInitializeCardPaymentData}
      transactionSuccessComponent={transactionSuccessComponent}
      cancelServiceFeeError={cancelServiceFeeError}
      cancelServiceFeeSuccess={cancelServiceFeeSuccess}
      onCancelServiceFeeClear={onCancelServiceFeeClear}
    />
  ) : (
    loadingOrFailedFetching
  );

  return (
    <Page
      title={intl.formatMessage({ id: "ServiceFeePage.title" })}
      scrollingDisabled={scrollingDisabled}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
         <div>{panel}</div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter className={css.footer}>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    fetchServiceFeeInProgress,
    fetchServiceFeeError,
    transactionRef,
    cancelInProgress,
    cancelServiceFeeError,
    defineSuspiciousInProgress,
    defineSuspiciousError,
    cancelServiceFeeSuccess
  } = state.ServiceFeePage;
  const { currentUser,  currentUserHasListings, userProviders } = state.user;
  const transactions = getMarketplaceEntities(state, transactionRef ? [transactionRef] : []);
  const transaction = transactions.length > 0 ? transactions[0] : null;

  return {
    fetchServiceFeeInProgress,
    fetchServiceFeeError,
    transactionRef,
    cancelInProgress,
    cancelServiceFeeError,
    defineSuspiciousInProgress,
    defineSuspiciousError,
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    transaction,
    currentUserHasListings,
    currentUserProviderId: userProviders && !!userProviders.length && userProviders[0].id.uuid,
    cancelServiceFeeSuccess
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCancel: data => dispatch(cancelServiceFee(data)),
    callSetInitialValues: (setInitialValues, values) => dispatch(setInitialValues(values)),
    onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
    onCancelServiceFeeClear: () => dispatch(cancelServiceFeeClear()),
  };
};

const ServiceFeePage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ServiceFeePageComponent);

ServiceFeePage.loadData = loadData;
ServiceFeePage.setInitialValues = setInitialValues;

export default ServiceFeePage;
